<template>
  <div @click="outSide" class="modal-main" v-if="mapModal">
    <!-- Modal content -->
    <div @click.stop="" ref="modal" class="content-modal">
      <div class="mb-2 font-weight-bold">Verifikasi lokasi</div>
      <div class="">
        <div v-if="!check">
          <div class="mb-2" v-if="isLoadingMap">
            <div v-if="innerLoc">Yay...kamu berada di radius kantor</div>
            <div v-else>
              Ops.. kamu diluar radius kantor, refresh browser sekarang untuk
              memperbarui lokasi
            </div>
          </div>
          <div v-if="isLoadingMap2 === true">
            Sedang mengambil peta, silahkan tunggu...
          </div>
          <div style="height: 300px" id="map"></div>
        </div>
        <div v-if="!innerLoc">
          <div class="d-flex align-items-center mt-2">
            <input
              @change="locationRefresh"
              class="check"
              type="checkbox"
              v-model="check"
            />
            Luar Kota
          </div>
          <div class="outcity-title">*Centang jika tugas luar kota</div>
          <textarea
            v-if="check"
            v-model="writeLocation"
            class="form-control mb-3"
            rows="3"
            placeholder="Keterangan Lokasi Luar Kota"
            resize="none"
          ></textarea>
        </div>
      </div>
      <div class="footer-modal mt-3">
        <base-button size="md" @click="toggleModal" type="maroon"
          ><span class="font-weight-bolder">Batal</span></base-button
        >
        <base-button
          :disabled="disableBtn"
          @click="confirmPresence"
          size="md"
          type="success"
          ><span class="font-weight-bolder font">{{
            isLoading ? "Loading..." : "Konfirmasi"
          }}</span></base-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import L from "leaflet";
import { Select, Option } from "element-ui";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    modals: Boolean,
    requestNext: Object,
  },
  data: () => ({
    mapModal: false,
    check: false,
    isLoadingMap: false,
    isLoadingMap2: false,
    map: null,
    innerLoc: false,
    outerLoc: false,
    lat: null,
    lng: null,
    writeLocation: "",
    isLoading: false,
  }),
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  computed: {
    ...mapState("attendance", ["locationOffices"]),
    targetLoc() {
      return this.locationOffices.map((item) => ({
        latitude: item.officeLatitude,
        longitude: item.officeLongitude,
        placeName: item.officeName,
      }));
    },
    disableBtn() {
      if (this.innerLoc === true) {
        return this.isLoading ? true : false;
      } else {
        if (this.check === true) {
          return this.writeLocation.length <= 10 || this.isLoading === true
            ? true
            : false;
        } else {
          return true;
        }
      }
    },
  },
  methods: {
    ...mapActions("attendance", ["enterPresence", "leavePresence"]),
    notifyVue(type = "default", message) {
      this.$notify({
        message,
        timeout: 3000,
        icon: "ni ni-bell-55",
        type,
      });
    },
    toggleModal() {
      this.isLoadingMap = false;
      this.check = false;
      this.mapModal = !this.mapModal;
    },
    async getLocation() {
      this.isLoadingMap2 = true;
      try {
        const coordinates = await this.$getLocation({
          enableHighAccuracy: true,
        });

        this.isLoadingMap = false;
        //set gps location
        this.lat = coordinates.lat;
        this.lng = coordinates.lng;
        const byGps = {
          latitude: coordinates.lat,
          longitude: coordinates.lng,
        };

        //initial map
        this.map = L.map("map").setView([-2.54893, 118.01486], 3);
        L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(this.map);
        this.map.setView(new L.LatLng(coordinates.lat, coordinates.lng), 17);

        //marker location by gps
        let marker = L.marker([coordinates.lat, coordinates.lng]).addTo(
          this.map
        );

        //matching gps with location target
        this.targetLoc.forEach((loc) => {
          //add radius sign with location target
          const mCircle = L.circle([loc.latitude, loc.longitude], {
            color: "red",
            fillColor: "#f03",
            fillOpacity: 0.2,
            radius: 100,
          }).addTo(this.map);

          mCircle
            .bindTooltip(loc.placeName, {
              direction: "top",
              offset: [0, -60],
              permanent: true,
            })
            .openTooltip();

          //check the gps location in the radius or not
          if (this.calcCrow(loc, byGps) < 100) {
            this.innerLoc = true;
          } else {
            this.outerLoc = true;
          }
        });
        if (this.map) {
          this.isLoadingMap = true;
          this.isLoadingMap2 = false;
        }
      } catch (err) {
        if (err === "no position access") {
          this.notifyVue(
            "danger",
            "Dimohon untuk memberi ijin lokasi, refresh browser jika masih muncul pesan ini"
          );
          this.toggleModal();
        }
      }
    },
    calcCrow(targetLoc, byGps) {
      const toRad = (val) => {
        return (val * Math.PI) / 180;
      };
      let R = 6371000; //in meters
      let dLat = toRad(byGps.latitude - targetLoc.latitude);
      let dLon = toRad(byGps.longitude - targetLoc.longitude);
      let lat1 = toRad(targetLoc.latitude);
      let lat2 = toRad(byGps.latitude);

      let a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) *
          Math.sin(dLon / 2) *
          Math.cos(lat1) *
          Math.cos(lat2);
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      let d = R * c;
      return d;
    },
    async confirmPresence() {
      try {
        this.isLoading = true;
        if (!this.lat && !this.lng)
          throw "Dimohon untuk memberi ijin lokasi, refresh browser jika masih muncul pesan ini";
        const request = () => {
          if (!this.check) {
            return {
              employeeId: this.requestNext.employeeId,
              password: this.requestNext.password,
              latitude: this.lat,
              longitude: this.lng,
            };
          } else {
            return {
              employeeId: this.requestNext.employeeId,
              password: this.requestNext.password,
              latitude: this.lat,
              longitude: this.lng,
              userIsOutstation: 1,
              userOutstationDescription: this.writeLocation,
            };
          }
        };
        if (this.requestNext.tabAttendance === 1) {
          await this.enterPresence(request());
          this.notifyVue("success", "Enter presence is success");
          this.isLoading = false;
        } else {
          await this.leavePresence(request());
          this.notifyVue("success", "Leave presence is success");
          this.isLoading = false;
        }
        this.$router.push("/auth/login");
      } catch (err) {
        if (err?.response?.status === 401) {
          this.notifyVue("danger", err.response.data.error);
        } else if (err?.response?.status === 400) {
          this.notifyVue("danger", err.response.data.error);
        } else {
          this.notifyVue("danger", err);
        }
        this.isLoading = false;
      }
    },
    locationRefresh() {
      this.getLocation();
    },
    outSide() {
      this.toggleModal();
    },
  },
  watch: {
    async modals() {
      this.toggleModal();
      this.getLocation();
    },
  },
};
</script>

<style lang="scss" src="../../style/modalStyles.scss" scoped></style>
